<template>
  <div class="radioFestiva">
    <img class="bg" src="../../assets/img/radioFestiva.png" alt="">
    <div class="box">   
      <div class="portraitBox">
        <div class="pors">
           <img class="portrait" crossorigin="*"  :src="`${hostAvatar}?time=${Date.now().toString()}`" alt="">
           <div class="ceng">
              <div class="name">{{nickname}}</div>
              <div class="program">{{radio_name}}</div>
           </div>
          
        </div>
        <div class="scanning" v-show="from1=='app'">
          <div class="left">
            <p class="a">我在参加听见广播年度主持人评选</p>
            <p class="b">扫描二维码为我助力</p>
          </div>
          <div class="right">
            <div class="qrcode">
                <vue-qr
                    :text="loginUrl"
                    :size="200"
                    :margin="16"
                    whiteMargin ='true'
                    ref="Qrcode"
                    class="vue-qr-img"
                   
                    >
                </vue-qr>
            </div>
          </div>
        </div>
      </div>
     <div class="btm" v-show="from1=='app'" @click="getimg">
        <span >分享拉关注</span>
     </div>
      <div @click="follow()" class="btm" v-show="from1!='app'">
        <span>关注TA</span>
     </div>
    </div>
    <!-- 登录弹窗 -->
     <div class="stationLogin" @click.self="loginhide()" v-show="loginShow==1">
    <div class="footer">
        <div class="loginContainer">
          
              <div class="getCode">
                <!-- <p class="fontsTips">您有5元现金待领取！填写手机号下载 听见广播APP登录获得更多！</p> -->
                <div class="telAndcode">
                  <div class="tel">
                    <input id='tel' type="tel"  placeholder="请输入11位手机号" class="telInput" maxlength="11"  v-model="tel" @input="setButtonStatus" > 
                  </div>
                  <div class="code">
                    <!-- @blur="isBlur" -->
                    <input  type="tel" placeholder="请输入短信验证码"  class="codeInput"  v-model="code" maxlength="6"  >
                    <span class="sendCode"    v-if="telLength !='1' && sending"  style="background:rgba(0,0,0,.2);;color:rgba(255, 253, 252, 1);">发送验证码</span>
                    <span class="sendCode" @click.stop="sendCode()"    v-if="telLength == '1' && sending" :disabled="isDisabled"  style="background:rgba(255, 35, 35, 1);color:rgba(255, 255, 255, 1);">发送验证码</span>
                    <span v-if="!sending" style="background:rgba(255,35,35,.87);color:#fff;">{{second}}s</span> 
                  </div>
                </div>
            </div>
            <div class="reallogin">
              <p  v-if="!isdis"  >
                  <span class="button1">关 &nbsp;注</span>
              </p>
              <p  @click.stop="reallogin()"  v-if="isdis" :disabled="isDisabled1">
                  <span class="button1 button2">关  &nbsp;注</span>
              </p>
            </div>
          
        </div>
      
    </div>
  
  </div>
  </div>

  
</template>

<script>
import { Toast } from 'mint-ui';
import { Indicator } from 'mint-ui';
import axios from 'axios';
import html2canvas from 'html2canvas';
import vueQr from 'vue-qr';
import shareMsg from '../../assets/js/common/shareConfig.js';
import share from '../../assets/js/common/share.js';
export default {
  name: 'radioFestiva',
  data(){
    return{
       //二维码链接
      loginUrl:'',
      //截取的图片
      imgpath:'',
      imgpath1:'',
      dataUrl:[],//二维码的base64地址
      from1:'',
       isDisabled:false,
      isDisabled1:false,
      isdis:false,
      sending:true,
      second:60,
      tel:'',
      code:'',
      returnUrl:'',
      telLength:'',
      //邀请人token
      token:'',
      salt:'',
      token1:'',
      salt1:'',
      //登录弹窗
      loginShow:'0',
      uri:'',
      //主持人头像
      hostAvatar:'',
      nickname:'',   //昵称
      radio_name:'',  //电台名  
      //opendId
      opendId:'',
      wxUrl:'',
      wxCode:'',
      tokens:'',
    }
  },

  methods:{
    // 嵌入app获取用户登陆状态
    onWebResponse:function(str) {
      return new Promise((resolve,reject)=>{
          var obj=JSON.parse(str);
          var action=obj.action;
          var self=this;
          var content=obj.content;
          if (action=='setUserInfo') {
              self.did1=content.did;
              self.token1=content.token;
              self.salt1=content.salt;
              if (self.token1=='') {
                  self.cbct.setCookie('token2','TOKEN'); 
              }else{
                  self.cbct.setCookie('token2',self.token1);
              }
              if (self.salt1=='') {
                  self.cbct.setCookie('salt2','SALT'); 
              }else{
                  self.cbct.setCookie('salt2',self.salt1);
              }
              self.getdate()
              var src = this.cbct.https().split('channels-')[1].split('.')[0];
              if(src != ''&& src != undefined){
                  if(src != 'dev' && src != 'test'){
                      src = '';
                  }else{
                      src = src+'.';
                  }
              }
              self.loginUrl = 'http://channels.h5.'+src+'cbct.cn/radioFestiva?state='+this.cbct.getCookie('token2')+'&salt='+this.cbct.getCookie('salt2')
             
          }
          resolve()
      })
    },
    // base64转二进制流
    tofileobj(data) {
      const binary = atob(data.split(',')[1])
      const mime = data.split(',')[0].match(/:(.*?);/)[1]
      const array = []
      for (let i = 0; i < binary.length; i++) {
          array.push(binary.charCodeAt(i))
      }
      const fileData = new Blob([new Uint8Array(array)], {
          type: mime
      })

      const file = new File([fileData], `${new Date().getTime()}.png`, { type: mime })
      return file
    },
    getimg(){
      $('.ceng').css({'background':'none'})
      // if(this.cbct.getCookie('fissionToken') == 'TOKEN' || this.cbct.getCookie('fissionToken') == ''){
      //     return this.gotoLoginPage();
      // }
      // let jumptype = isshare;

      // this.isCeng='1';
      // this.isS='0';
        Indicator.open({
          text: '图片生成中...',
          spinnerType: 'fading-circle'
        });
      window.pageYOffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
          setTimeout(() => {
            html2canvas(document.querySelector('.portraitBox'), {
              taintTest: true, //在渲染前测试图片(没整明白有啥用)
              useCORS: true, //使用跨域(当allowTaint为true时这段代码没什么用)
              width:$('.portraitBox').width()-2,//设置canvas尺寸与所截图尺寸相同，防止白边
              height:$('.portraitBox').height(),//防止白边
            }).then((canvas)=>{
                const imgpath = canvas.toDataURL('image/png', 1.0); //将图片转为base64, 0-1 表示清晰度
                let form = this.tofileobj(imgpath)
                console.log('form',imgpath);
                let fd = new FormData()
                fd.append('name',form)
                fd.append('type','image')
                this.api2.post(this.cbct.https()+'/h5/upload-image',fd, this.qs.stringify({      
                })).then((response)=>{
                        if(response.c == this.cbct.code.successRes){  
                            const shareImg = response.d.url//给客户端传的图片
                            console.log(shareImg,'img')
                            this.$nextTick(function () {
                                Indicator.close();
                                 $('.ceng').css({'background':' linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .63) 100%)'})
                                if(this.from1 =='app'){
                                  shareMsg.shareConfig(
                                    'app','1','1','','','',shareImg,'','0'
                                  )
                                }          
                            })
                        }else if(response.c == this.cbct.code.noLogin){
                            Toast({
                                message:response.m ,
                                position: 'center',
                                duration: 1000
                            });
                            timing.time();
                        }else if(response.c == this.cbct.code.raleNoLogin){
                            //  self.$router.replace({path:'./fissionLogin'});
                        }else{
                            // self.isClick=true;
                            // self.isCeng='0';
                            // this.isS='1';
                            Indicator.close();
                            Toast({
                                message:response.m,
                                position: 'center',
                                duration: 1000
                            });
                        
                        }
                    }).catch((error)=>{console.log(error);})
                })
                        
            }, 2000);
            // }
             
        },
     isWeiXin:function () {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return true;
        } else {
            return false;
        }
    },
     getopendId(){
       this.api2.post(this.cbct.https()+'/h5/base/oauth', this.qs.stringify({
         code:this.wxCode
        })).then((response)=>{
            if(response.c == this.cbct.code.successRes){
              this.cbct.setCookie('opendId',response.d.openid); 
              // this.cbct.setCookie('token2',response.d.token);
              this.opendId =response.d.openid
              // this.token1 =response.d.token
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c == this.cbct.code.raleNoLogin){
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
            }else{
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
            }
            
         }
        ).catch((error)=>{console.log(error);})
    },
    wxCallback1(){
      var self = this;
       this.api2.post(this.cbct.https()+'/h5/snsapi/base', this.qs.stringify({
         type:'base',
         token:this.cbct.getCookie('hostToken')
        })).then((response)=>{
            if(response.c == this.cbct.code.successRes){
             
              window.location.href=response.d.url
              if(self.from1!='app'){
                if (self.$route.query.state) {
                  self.cbct.setCookie('hostToken',self.$route.query.state);
                  self.token1=self.$route.query.state
                }
              }
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c == this.cbct.code.raleNoLogin){
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
            }else{
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
            }
            
         }
        ).catch((error)=>{console.log(error);})
    },
    //获取信息
    getdate(){
      if(this.from1=='app'){
        this.tokens = this.cbct.getCookie('token2')
      }else{
         this.tokens = this.cbct.getCookie('hostToken')
      }
      this.api2.post(this.cbct.https()+'/user/info-api', this.qs.stringify({
          invite_token:this.tokens
        })).then((response)=>{
            if(response.c == this.cbct.code.successRes){ 
                this.hostAvatar=response.d.avatar,
                this.nickname=response.d.nickname,
                this.radio_name=response.d.radio_name;
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c == this.cbct.code.raleNoLogin){
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
            }else{
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
            }
            
         }
        ).catch((error)=>{console.log(error);})
    },
     setButtonStatus() {
        var reg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!reg.test(this.tel)) {
           this.telLength = '';
        }else{
          this.telLength = '1';
        }
        if(this.code == '' || this.tel =='') {
            this.isdis = false;
        }else{
            this.isdis=true;
        }
    },
    //发送验证码
    sendCode(){
      if (!this.sending) {
        return
      }
      let self=this;
      var reg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (this.tel=='' || this.tel==undefined) {
           Toast("请输入手机号")
           this.sending=true;
           this.isDisabled=true;
           return;
      }else if(!reg.test(this.tel)) {
           Toast("请输入正确的手机号")
           this.sending=true;
           this.isDisabled=true;
           return;
      }else{
        this.sending=false; 
        this.isDisabled=true;
        this.timeDown();
        let self=this;
      this.api2.post(this.cbct.https()+'/v2/jubilee/send-code', this.qs.stringify({
            mobile:this.tel
        })).then((response)=>{
            if(response.c == this.cbct.code.successRes){ 
                  setTimeout(()=>{
                    Toast({
                      message: '发送成功',
                      position: 'center',
                      duration: 5000
                    }); 

                  },500)
                   
                   
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c == this.cbct.code.raleNoLogin){
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
            }else{
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
            }
            
         }
        ).catch((error)=>{console.log(error);})
      }
    },
    //登录弹窗
    follow(){
      var self = this;
       this.loginShow =1;
        // if (self.cbct.getCookie('token3')=='TOKEN' || self.cbct.getCookie('token3')) {
        //   this.loginShow =1;
        // }else{
        //   window.location.href='http://devds.h5.cbct.cn/radioFestival?isToken='+this.cbct.getCookie('ds_token')+'&oId='+this.opendId
        // }

    },
    loginhide(){
      this.loginShow =0;
    },
    reallogin(){
      let self=this;
      this.isDisabled1=true;
      setTimeout(()=>{
        self.isDisabled1=false;
      },250)
        
      this.api2.post(this.cbct.https()+'/h5/channel/user/bind-mobile', this.qs.stringify({
            mobile:this.tel,
            code:this.code,
            invite_token:this.cbct.getCookie('hostToken'),
          })).then((response)=>{
              if(response.c == this.cbct.code.successRes){ 
                self.cbct.setCookie('token3',response.d.token);
                self.cbct.setCookie('salt3',response.d.salt);
                self.cbct.setCookie('ds_token',response.d.ds_token);
                window.location.href=this.cbct.dsUrl()+'/radioFestival?isToken='+this.cbct.getCookie('ds_token')+'&oId='+this.opendId+'&token3='+this.cbct.getCookie('token3')+'&salt3='+this.cbct.getCookie('salt3')

            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c == this.cbct.code.raleNoLogin){
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
            }else{
                Toast({
                    message: response.m,
                    position: 'center',
                    duration: 5000
                });
            }
            
        }
      ).catch((error)=>{console.log(error);})
           
    },
    timeDown(){
        this.isDisabled=true;
        let result=setInterval(()=>{
        --this.second;
        if (this.second<0) {
          clearInterval(result);
          this.sending=true;
          this.isDisabled=false;
          this.second=60;
        }
      },1000)
    },
   onBridgeReady() {
      WeixinJSBridge.call('hideOptionMenu');
    },

  },
  created(){
    if(this.$route.query.from1){
      this.from1 = this.$route.query.from1
    }
    if(this.$route.query.code){
      this.wxCode = this.$route.query.code
    }
    var self = this;
    //  axios.defaults.headers = {
    //         'Content-Type':'application/x-www-form-urlencoded',
    //     };
      axios.defaults.headers = {
          'Content-Type':'application/x-www-form-urlencoded',
      };
     this.api2.post(this.cbct.https()+'/admin/time', {  
        })
        .then(function (response) {
            if(response.c == self.cbct.code.successRes){
                var timing = response.d.time - Date.parse(new Date()); 
                 self.cbct.setCookie('timing',timing);
                   if(self.from1!='app'){
            
                      if (self.$route.query.state) {
                        self.cbct.setCookie('hostToken',self.$route.query.state);
                        self.token1=self.$route.query.state
                      }
                      if (self.$route.query.salt) {
                        self.cbct.setCookie('hostSalt',self.$route.query.salt);
                        self.salt1=self.$route.query.salt
                      }
                    if (self.$route.query.code) {
                        self.wxCode=self.$route.query.code
                        self.getopendId()
                      }else{
                        self.wxCallback1()
                      }
                       self.getdate()
                     
                  }
            }})  
    $('html').css('min-height','100%');
    // this.timing.time();
  },
  mounted(){
    var self=this;
    this.token = this.cbct.getCookie('token3') || '';
    this.salt = this.cbct.getCookie('salt3') || '';
    var src = this.cbct.https().split('channels-')[1].split('.')[0];
    if(src != ''&& src != undefined){
        if(src != 'dev' && src != 'test'){
            src = '';
        }else{
            src = src+'.';
        }
    }
     
    // this.$nextTick(()=>{
    //    setTimeout(() => {
          
    //     if (typeof WeixinJSBridge == "undefined") {
    //         if (document.addEventListener) {
    //             document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
    //         } else if (document.attachEvent) {
    //             document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
    //             document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
    //         }
    //     } else {
    //         onBridgeReady();
    //     }
    // },1000)
    // })
   if(this.from1!='app'){
       this.loginUrl = 'http://channels.h5.'+src+'cbct.cn/radioFestiva?state='+this.cbct.getCookie('hostToken')+'&salt='+this.cbct.getCookie('hostSalt')
   }else{
      this.loginUrl = 'http://channels.h5.'+src+'cbct.cn/radioFestiva?state='+this.cbct.getCookie('token2')+'&salt='+this.cbct.getCookie('salt2')
   }
    share.share(this.loginUrl,'快来支持你喜欢的听见广播主持人','新用户注册有惊喜','https://seefm.oss-cn-beijing.aliyuncs.com/image/icon.png');
    share.QQshare(this.loginUrl,'快来支持你喜欢的听见广播主持人','新用户注册有惊喜','https://seefm.oss-cn-beijing.aliyuncs.com/image/icon.png');
    $('title').html('2020年度电台盛典');
    if (this.from1 == 'app') {
        window['onWebResponse'] = (str)=>{
        self.onWebResponse(str)
        }
        $('radioFestiva').css(' overflow','hidden;');
    }
   
  },
  destroyed(){
    $('html').css('position','static');
    Indicator.close();
    //  document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
    //     WeixinJSBridge.call('showOptionMenu');
    // });
  },
  components:{
      vueQr
  },
  watch:{
    tel(n,o){
      var reg=/^1\d{10}$/
      if (n=='' || n== undefined || n==null) {
        this.isdis=false;
      }else if( !reg.test(n)){
        this.isdis=false;
      }else if(reg.test(n) != '' && this.code !=''){
        this.isdis=true;
      }
    },
    code(n,o){
       var reg=/^1\d{10}$/
       if (n=='' || n== undefined || n==null) {
        this.isdis=false;
      }else if( !reg.test(this.tel)){
        this.isdis=false;
      }
      else if(n != '' && reg.test(this.tel) !=''){
        this.isdis=true;
      }
    }
  },
}


</script>
<style scoped lang="scss">
  .radioFestiva{
    width: 100%;
    height: 100vh;
    background: #5A0000;
    position: relative;
   
    .bg{
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }
    .box{
      position: absolute;
      top: 4.1rem;
      left:.93rem;
      width: 5.64rem;
      height: auto;
      .portraitBox{
        width: 100%;
        height: auto;
        box-sizing: border-box;
        overflow: hidden;
        border-radius: .16rem .16rem .08rem .08rem;
        background: #D8D8D8;
        .pors{
          width: 100%;
          height:5.5rem;
          position: relative;
           background: #aaa;
          .portrait{
            width: 100%;
            height:100%;
          }
          .ceng{
            width: 100%;
            height: 1.44rem;
            // background: rgba(0,0,0,.1);
            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, .63) 100%);
            position: absolute;
            left: 0;
            bottom: 0;
          }
          .name{
            font-size: .4rem;
            color: #fff;
            position: absolute;
            right: 0;
            bottom: .68rem;
            font-weight: 600;
            width: auto;
            height: auto;
            overflow: hidden;
            padding:0 .32rem;
            background: url('../../assets/img/hostbgs.png') no-repeat;
            background-size: auto 100%;          
            text-shadow: 0px .02rem .04rem rgba(0, 0, 0, 0.25);
            // .name1{
            //     font-size: .4rem;
            //     color: #fff;
            //     position: absolute;
            //     right: 0;
            //     bottom: .08rem;
            //     font-weight: 600;
            //     width: auto;
            //     min-width: 1.6rem;
            //     height: auto;
            //     padding:0 .32rem;
            //     text-shadow: 0px  -.1rem .05rem rgba(0,0,0,.1);
            //     z-index: 1;
            //   }
            .name2{
              width: 100%;
              height:.3rem ;
              position: absolute;
              bottom: 0;
              right: 0;
              border: none;
              overflow: hidden;
              //background: linear-gradient(180deg, rgba(255, 47, 47, 0) 0%, #5F0000 100%);
              background: url('../../assets/img/hostbgs.png') no-repeat;
              background-size: auto 100%;
             // background: linear-gradient(180deg, rgba(255, 47, 47, 0) 0%, #5F0000 100%);
              z-index: 0;
            }
          }
          .program{
            font-size: .28rem;
            color: #fff;
            position: absolute;
            right: .32rem;
            bottom: .14rem;
            font-weight: 600;
          }
        }
        .scanning{
          width: 100%;
          height: 2.16rem;
          background: #fff;
          .left{
            float: left;
            width: 3.04rem;
            height: auto;
            margin-left: .3rem;
            .a{
              height: .92rem;
              font-size: .34rem;
              font-family: IdeaFonts-ZongYiTi, IdeaFonts;
              font-weight: normal;
              color: #000000;
              line-height: .46rem;
              letter-spacing: .01rem;
              text-align: left;
              margin: .46rem 0 .1rem 0;
            }
            .b{
              font-size: .24rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.5);
              line-height: .34rem;
              text-align: left;
            }
          }
          .right{
            float: right;
            width:1.62rem ;
            height: 1.62rem;
            overflow: hidden;
            margin: .3rem .32rem 0 0;
            img{
              width: 100%;
            }
          }
        }
      }
      .btm{
        width: 100%;
        height: 1.16rem;
        background: #CB1717;
        border-radius: .08rem .08rem .16rem .16rem;
        font-size: .36rem;
        line-height: 1.16rem;
        font-weight:600;
        text-align: center;
        color: #fff;
      }
    }
      .stationLogin{
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        box-sizing: border-box;
        background: rgba(0, 0, 0, 0.56);
        z-index: 4;
        overflow: hidden;
        .bg{
          // position: absolute;
          // top: 0;
          // left: 0;
          width: 100%;
          height:auto;
          z-index: 1;
        }
        .footer{
          position: fixed;
          bottom:0;
          height: 4.66rem;
          width: 100%;
          left:0;
          z-index: 3;
          background: #fff;
          border-radius:.4rem .4rem 0 0 ;
        }
        .loginContainer{
          width: 100%;
          box-sizing: border-box;
          // position: absolute;
          // top: 0.98rem;
          // z-index: 20;
          .getCode{
            margin-top: .44rem;
            .fontsTips{
              font-size:0.26rem;
              font-weight:500;
              color:rgba(193,247,255,.7);
              padding: 0 1.56rem;
              line-height: 1.3;
              margin-bottom: 0.44rem;
            }
            .telAndcode{
              .tel ,.code{
                width: 100%;
                box-sizing: border-box;
                padding: 0 0.3rem;
                font-size: 0.28rem;
                input{
                  background:rgba(255,255,255,1);
                }
              }
              input{  
                  padding: 0.22rem 0;
                  width: 100%;
                  height: 0.88rem;
                  padding-left: 0.4rem;
                  box-sizing: border-box;
                  outline: none;
                  border-radius:0.16rem;
                  color:rgba(0,0,0,1);
                  font-size:0.28rem;
                  font-weight:500;
                  
                  border: 1px solid rgba(0, 0, 0, 0.3);
                  line-height:0.44rem;
              }
              input::-webkit-input-placeholder {
                font-weight:500;
                color:rgba(0,0,0,.3);
              }
              .code{
                margin-top: 0.48rem;
                display: flex;
                .codeInput{
                  text-align: left;
                  width: 4.5rem;
                  box-sizing: border-box;
                  margin-right:.16rem;
                }
                span{
                    display: block;
                    width: 2.24rem;
                    height: 0.88rem;
                    line-height: 0.88rem;
                    box-sizing: border-box;
                    background:rgba(255, 196, 21, 1);
                    border-radius:0.16rem;
                    text-align: center;
                    font-weight:500;
                    font-size:0.28rem;
                    color: rgba(161, 46, 11, 1);
                  }
              }
            }
          }
          .reallogin{
            margin-top: 0.38rem;
            font-size: 0.28rem;
            p{
              padding:0 0.3rem;
              font-weight:500;
              // color:rgba(91,72,36,.49);
              margin: auto;
              // border-radius:0.44rem;
              .button1{
                display: inline-block;
                width: 100%;
                height: 0.88rem;
                font-weight:500;
                font-size:0.32rem;
                line-height: .88rem;
                background:rgba(0,0,0,.2);
                color:#fff;
                border-radius:0.16rem;
              }
              .button2{
                color:rgba(255, 255, 255, 1);
                background:rgba(255, 35, 35, .87);
               // box-shadow:0px -1px 0.16rem 0px rgba(245,166,35,0.95);
                // border-radius:0.44rem;
                // border:1px solid;
               // border-image:linear-gradient(180deg, rgba(255,203,119,1), rgba(247,107,28,1)) 1 1;
              }
              
            }
          }
        }
        .loginSuccess{
          display: none;
          .isImg{
            width: 2.82rem;
            height: 2.82rem;
            margin: auto;
            margin-top: -1.16rem;
            img{
              width: 100%;
            }
          }
          .fontes{
            margin-top: 0.16rem;
            font-weight:500;
            color:rgba(255,255,255,1);
            font-size:0.32rem;
          }
          .isButton{
            width: 100%;
            box-sizing: border-box;
            padding: 0 1.06rem;
            margin-top: 0.86rem;
            .button1{
                width: 100%;
                border-radius:0.48rem;
                font-weight:500;
                background:rgba(53,238,241,1);
                color:rgba(54,32,104,1);
                font-size:0.32rem;
                height: 0.96rem;
                line-height: 1rem;
              }
          }

        }
       
   }
  }
</style>

